import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    select
  ) => {
    const option = select.options[select.selectedIndex].value
    const form = select.closest('form')
    const ssl = one('input[name="new_ssl"]', form)
    const port = one('input[name="new_port"]', form)
    
    if (port) {
      if (option === 'imap4') {
        port.value = (ssl && ssl.checked) ? 993 : 143
      } else if (option === 'pop3') {
        port.value =  (ssl && ssl.checked) ? 995 : 110
      }
    }
  }
})

export default protocol => {
  onInput.listen(protocol)
}
